import { findLabelByKey } from '../utils/internal';
import { LABEL_ADD_TO_BASKET_VISIBLE } from './constants';
export const mapCanBeSold = labels => labels?.find(findLabelByKey(LABEL_ADD_TO_BASKET_VISIBLE)) !== undefined;
//# sourceMappingURL=mapCanBeSold.js.map